export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const FORGET_PASSWORD_REQUEST = 'FORGET_PASSWORD_REQUEST';
export const FORGET_PASSWORD_SUCCESS = 'FORGET_PASSWORD_SUCCESS';
export const FORGET_PASSWORD_FAILURE = 'FORGET_PASSWORD_FAILURE';

export const FORGET_PASSWORD_RESET_REQUEST = 'FORGET_PASSWORD_RESET_REQUEST';
export const FORGET_PASSWORD_RESET_SUCCESS = 'FORGET_PASSWORD_RESET_SUCCESS';
export const FORGET_PASSWORD_RESET_FAILURE = 'FORGET_PASSWORD_RESET_FAILURE';

// MFA action types
export const VERIFY_MFA_REQUEST = 'VERIFY_MFA_REQUEST';
export const VERIFY_MFA_SUCCESS = 'VERIFY_MFA_SUCCESS';
export const VERIFY_MFA_FAILURE = 'VERIFY_MFA_FAILURE';

// Single action to clear all transient alert states
export const CLEAR_AUTH_ALERTS = 'CLEAR_AUTH_ALERTS';